import { StyleSheet } from "react-native";
import { color_333333, color_999999, color_BEBEBE, color_main, ColorGrey, ColorLine, white, color_666666, color_EDEEF1, color_EEF3FA } from "../../assets/style/colors";

const styles = StyleSheet.create<any>({
  // ...原有的styles内容，直接复制即可...
  // 这里只是分离样式，内容与原文件一致
  listContainer: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  listContent: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 20,
  },
  itemContainer: {
    backgroundColor: white,
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  itemText: {
    color: color_333333,
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  itemSubText: {
    color: color_999999,
    fontSize: 14,
  },
  itemSeparator: {
    height: 12,
  },
  addModalContainer: {
    backgroundColor: "rgba(0,0,0,0.5)",
    top: 0,
    bottom: 0,
    start: 0,
    end: 0,
    position: "absolute",
    flexDirection: "column-reverse",
  },
  addModalBottomContainer: {
    backgroundColor: white,
    borderTopEndRadius: 12,
    borderTopStartRadius: 12,
    alignItems: "center",
  },
  inputContainer: {
    height: 44,
    width: "90%",
    fontSize: 16,
    paddingHorizontal: 12,
    marginTop: 20,
    color: color_333333,
    backgroundColor: ColorGrey,
    borderRadius: 10,
  },
  addComplete: {
    marginTop: 40,
    height: 50,
    width: "50%",
    backgroundColor: ColorGrey,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
  },
  addTextComplete: {
    color: color_999999,
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "",
  },
  webModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  webModalContainer: {
    backgroundColor: white,
    borderRadius: 12,
    width: "90%",
    maxWidth: 500,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  },
  webModalHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: ColorLine,
  },
  webModalTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: color_333333,
  },
  webCloseButton: {
    width: 32,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  webCloseText: {
    fontSize: 28,
    color: color_999999,
    lineHeight: 28,
  },
  webModalContent: {
    padding: 24,
  },
  webFormField: {
    marginBottom: 24,
  },
  webLabel: {
    color: color_333333,
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 8,
  },
  webInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 8,
    paddingHorizontal: 16,
    minHeight: 48,
    backgroundColor: "white",
  },
  webInput: {
    flex: 1,
    height: 48,
    color: color_333333,
    fontSize: 16,
  },
  webButtonContainer: {
    alignItems: "flex-start",
  },
  webSubmitButton: {
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 48,
    minWidth: 200,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none",
    transition: "opacity 0.2s, background-color 0.2s",
  },
  webSubmitButtonText: {
    fontSize: 16,
    fontWeight: "600",
  },
  emptyContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: white,
  },
  emptyText: {
    color: color_999999,
    fontSize: 16,
  },
  emptyContainerButton: {
    backgroundColor: ColorGrey,
    borderRadius: 8,
    paddingVertical: 12,
    marginTop: 20,
    paddingHorizontal: 70,
  },
  emptyButton: {
    color: color_333333,
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "",
  },
  webDetailModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  webDetailModalContainer: {
    backgroundColor: white,
    borderRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    width: "90%",
    maxWidth: 700,
    maxHeight: "80%",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    display: "flex",
    flexDirection: "column",
  },
  webDetailModalContent: {
    flex: 1,
    minHeight: 400,
    maxHeight: 600,
    display: "flex",
    flexDirection: "column",
  },
  webDetailModalFooter: {
    borderTopWidth: 1,
    borderTopColor: ColorLine,
    backgroundColor: color_EDEEF1,
  },
  webDetailButtonContainer: {
    flexDirection: "row",
  },
});

export default styles;
